import { computed } from 'vue';
import { useStore } from "vuex";
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useLastNameField = (required, messages = {}) => {
  const validator = yup.string()
    .max(30, messages['max'] || '姓は30文字以内にしてください')
    .requirement(required, messages['requirement'] || '姓は必須項目です');
  const fieldName = computed(() => 'last_name');

  return { validator, fieldName }
}

export const useLastNameStore = () => {
  const store = useStore();
  const lastName = computed(() => store.state.formData.last_name);
  const dispatcher = computed(() => 'formData/setLastName');

  return { lastName, dispatcher }
}